<template>
  <Layout>
    <div class="dygaoyong-page">
      <div class="page-content">
        <!-- 页面头部 -->
        <div class="page-header">
          <div class="header-search">
            <div class="search-box" ref="searchBox">
              <div class="search-row">
                <el-input
                  ref="searchInput"
                  v-model="searchKeyword"
                  placeholder="请输入商品标题或关键词"
                  class="search-input-large"
                  clearable
                  @keyup.enter.native="handleSearch"
                  @clear="handleSearchClear"
                  @focus="handleSearchFocus"
                  @input="handleSearchInput"
                  @blur="handleSearchBlur"
                />
                <el-button class="search-button" type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
              </div>
              <div class="suggest-box" v-if="searchPanelMode === 'suggest' && suggestList && suggestList.length">
                <ul>
                  <li
                    v-for="(item, index) in suggestList"
                    :key="`${item.value}-${index}`"
                    class="suggest-item"
                    @click="fastSearch(item.value)"
                    @mousedown.prevent
                  >
                    <i class="el-icon-search"></i> {{ item.value }}
                  </li>
                </ul>
              </div>
              <div class="history-box" v-if="searchPanelMode === 'history' && searchHistory && searchHistory.length">
                <div class="history-header">
                  <span>搜索历史</span>
                  <span class="history-clear" @click="clearHistory" @mousedown.prevent>清空</span>
                </div>
                <ul>
                  <li
                    v-for="(item, index) in searchHistory"
                    :key="index"
                    class="history-item"
                    @click="fastSearch(item)"
                    @mousedown.prevent
                  >
                    <i class="el-icon-time"></i> {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 筛选区域 -->
        <el-card class="card-container" shadow="never">
          <div class="filter-section">
            <!-- 类目筛选 -->
            <div class="filter-group">
              <!-- <label class="filter-label">商品类目：</label> -->
              <el-radio-group v-model="categoryId" @change="handleCategoryChange">
                <el-radio-button v-for="category in categoryList" :key="category.cat_id" :label="category.cat_id">{{
                  category.cat_name
                }}</el-radio-button>
              </el-radio-group>
            </div>

          </div>
        </el-card>

        <!-- 商品列表 -->
        <div class="goods-list" v-loading="loading">
          <div v-if="goodsList.length === 0" class="empty-data">
            {{ loading ? "数据加载中..." : "暂无商品数据" }}
          </div>

          <div class="goods-grid" v-if="goodsList.length > 0">
            <div class="goods-item" v-for="(item, index) in goodsList" :key="`${item.origin_id || index}`">
              <div class="goods-card">
                <div class="goods-image">
                  <el-image :src="item.image || defaultImage" :preview-src-list="[item.image || defaultImage]" fit="contain" lazy>
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <span class="live-badge" v-if="item.author_name">
                    <img class="live-gif" src="@/assets/image/live.gif" alt="" />
                    <span class="live-author">{{ item.author_name }}</span>
                  </span>
                </div>

                <div class="goods-content">
                  <div class="goods-title" :title="item.title" @click="handleOpenGoods(item)">
                    {{ item.title }}
                  </div>
                  <div class="sub-title" :title="item.sub_title" @click="handleOpenGoods(item)">
                    {{ item.sub_title }}
                  </div>
                  <div class="sales-info-container">
                    <div class="shop-title">{{ item.shop_title }}</div>
                  </div>

                  <div class="price-row">
                    <div class="price-info">
                      <div class="current-price">
                        ￥<span class="price-number customFont">{{ item.final_price || item.origin_price }}</span>
                      </div>
                      <!-- <div class="original-price">￥{{ item.origin_price }}</div> -->
                    </div>
                    <div class="sales-info" v-if="item.sales_num">
                      <span class="sales-text">已售{{ formatSales(item.sales_num) }}</span>
                    </div>
                  </div>
                  <div class="meta-bar">
                    <div class="meta-item meta-item--primary">
                      <span class="meta-label">佣金比例</span>
                      <strong class="meta-value customFont">{{ getIncomeRate(item) }}%</strong>
                    </div>
                    <div class="meta-item meta-item--primary">
                      <span class="meta-label">预估佣金</span>
                      <strong class="meta-value customFont">¥{{ item.fan_price }}</strong>
                    </div>
                  </div>

                  <div class="action-row">
                    <el-button type="primary" style="width: 100%;" @click="handleGoodsClick(item)">立即推广</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 推广结果弹窗 -->
    <el-dialog title="推广链接" :visible.sync="promoteDialogVisible" :width="dialogWidth" class="promote-dialog" @close="handlePromoteDialogClose">
      <div v-loading="promoteLoading" class="promote-result">
        <div v-if="!promoteLoading && promoteResult" class="promote-fields">
          <div class="promote-field">
            <label>推广文案</label>
            <div class="field-value">
              <el-input v-model="promoteText" type="textarea" :rows="4" readonly class="field-input promote-copy" />
              <el-button size="small" type="primary" @click="copyField('promote_text', promoteText)">复制</el-button>
            </div>
          </div>
          <div class="promote-field" v-if="shortLink">
            <label>推广链接</label>
            <div class="field-value">
              <el-input :value="shortLink" type="input" readonly class="field-input" />
              <el-button size="small" type="primary" @click="copyField('short_link', shortLink)">复制</el-button>
            </div>
          </div>
          <el-button
            v-if="isMobile && shortLink"
            class="deeplink-button"
            type="primary"
            @click="openShortLink"
          >
            前往小程序购买
          </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="promoteDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout/index";
import {
  getCdfSunriseCateList,
  getCdfSunriseGoodsList,
  getGoodsUrl,
} from "@/api/public";

export default {
  name: "CdfSunriseIndex",
  components: {
    Layout,
  },
  data() {
    return {
      categoryList: [],
      categoryId: 0,
      goodsList: [],
      loading: false,
      searchKeyword: "",
      suggestTimer: null,
      suggestQuerySeq: 0,
      suggestList: [],
      searchHistory: [],
      searchPanelMode: "none",
      page: 1,
      hasMore: true,
      pageSize: 40,
      defaultImage: "https://img.huajuanyun.com/utools/2025/711/1752201507730.png",
      promoteDialogVisible: false,
      promoteLoading: false,
      promoteResult: null,
      shortLink: "",
      promoteText: "",
      currentPromoteGoods: null,
      isMobile: false,
    };
  },
  computed: {
    dialogWidth() {
      return this.isMobile ? "92%" : "560px";
    },
  },
  mounted() {
    this.init();
    window.addEventListener("scroll", this.handleScrollLoadMore, { passive: true });
    window.addEventListener("click", this.bodyCloseMenus);
    window.addEventListener("resize", this.updateDeviceType);
    this.updateDeviceType();
    this.loadHistory();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollLoadMore);
    window.removeEventListener("click", this.bodyCloseMenus);
    window.removeEventListener("resize", this.updateDeviceType);
    this.cancelSuggestRequest();
  },
  methods: {
    async init() {
      await this.getCategoryList();
      await this.getGoodsList();
    },
    async getCategoryList() {
      try {
        const response = await getCdfSunriseCateList({});
        if (response && response.data && response.data.list) {
          this.categoryList = [{ cat_id: 0, cat_name: "全部分类" }, ...response.data.list];
        }
      } catch (error) {
        console.error("获取中免日上分类失败:", error);
      }
    },
    async getGoodsList(loadMore = false) {
      this.loading = true;
      try {
        const targetPage = loadMore ? this.page + 1 : 1;
        const response = await getCdfSunriseGoodsList({
          keyword: this.searchKeyword || "",
          cate_ids: Number(this.categoryId) === 0 ? "" : this.categoryId,
          page: targetPage,
          pagesize: this.pageSize,
        });
        if (response && response.data) {
          const list = response.data.list || [];
          if (loadMore) {
            this.goodsList = [...this.goodsList, ...list];
          } else {
            this.goodsList = list;
          }
          this.page = targetPage;
          this.hasMore = list.length === this.pageSize;
        } else {
          if (!loadMore) {
            this.goodsList = [];
          }
        }
      } catch (error) {
        console.error("获取商品列表失败:", error);
        if (!loadMore) {
          this.goodsList = [];
        }
        this.$message.error("数据加载失败");
      } finally {
        this.loading = false;
      }
    },
    handleCategoryChange() {
      this.page = 1;
      this.hasMore = true;
      this.getGoodsList();
    },
    cancelSuggestRequest() {
      this.suggestQuerySeq += 1;
      if (this.suggestTimer) {
        clearTimeout(this.suggestTimer);
        this.suggestTimer = null;
      }
    },
    closeSearchPanels() {
      this.cancelSuggestRequest();
      this.searchPanelMode = "none";
      this.suggestList = [];
    },
    querySearchAsync(queryString) {
      const keyword = String(queryString || "").trim();
      if (!keyword) {
        this.cancelSuggestRequest();
        this.suggestList = [];
        this.searchPanelMode = "history";
        return;
      }
      const querySeq = ++this.suggestQuerySeq;
      this.suggestList = [];
      if (this.suggestTimer) clearTimeout(this.suggestTimer);
      this.suggestTimer = setTimeout(() => {
        if (querySeq !== this.suggestQuerySeq) {
          return;
        }
        const callbackName = `tbSugCb_${Date.now()}_${Math.floor(Math.random() * 100000)}`;
        const url = `https://suggest.taobao.com/sug?k=1&area=c2c&code=utf-8&q=${encodeURIComponent(keyword)}&callback=${callbackName}`;
        const script = document.createElement("script");
        script.src = url;
        window[callbackName] = (res) => {
          try {
            if (
              querySeq !== this.suggestQuerySeq ||
              this.searchPanelMode !== "suggest" ||
              String(this.searchKeyword || "").trim() !== keyword
            ) {
              return;
            }
            const list = Array.isArray(res && res.result) ? res.result.map((item) => ({ value: item[0] })) : [];
            this.suggestList = list;
          } catch (e) {
            this.suggestList = [];
          } finally {
            delete window[callbackName];
            if (script && script.parentNode) script.parentNode.removeChild(script);
          }
        };
        script.onerror = () => {
          delete window[callbackName];
          if (script && script.parentNode) script.parentNode.removeChild(script);
          if (querySeq === this.suggestQuerySeq) {
            this.suggestList = [];
          }
        };
        document.body.appendChild(script);
      }, 200);
    },
    handleSearch() {
      if (!this.searchKeyword || !this.searchKeyword.trim()) {
        this.$message.warning("请输入搜索关键词");
        return;
      }
      if (Number(this.categoryId) !== 0) {
        this.categoryId = 0;
      }
      // 记录搜索历史
      this.saveHistory(this.searchKeyword);
      this.closeSearchPanels();
      this.page = 1;
      this.hasMore = true;
      this.getGoodsList();
    },
    handleSearchClear() {
      this.searchKeyword = "";
      this.cancelSuggestRequest();
      this.suggestList = [];
      this.searchPanelMode = "history";
      this.page = 1;
      this.hasMore = true;
      this.getGoodsList();
    },
    handleSearchFocus() {
      // 聚焦时优先显示搜索历史；开始输入后再切到联想列表。
      this.cancelSuggestRequest();
      this.suggestList = [];
      this.searchPanelMode = "history";
    },
    handleSearchInput(val) {
      // 输入时切到联想列表；输入框清空后重新显示历史。
      const keyword = String(val || "").trim();
      if (!keyword) {
        this.cancelSuggestRequest();
        this.suggestList = [];
        this.searchPanelMode = "history";
        return;
      }
      this.searchPanelMode = "suggest";
      this.querySearchAsync(keyword);
    },
    handleSearchBlur() {
      // 延迟关闭，避免点击历史或联想项时先触发 blur 导致点击无效。
      setTimeout(() => {
        this.closeSearchPanels();
      }, 150);
    },
    fastSearch(val) {
      this.searchKeyword = val;
      this.categoryId = 0;
      this.handleSearch();
      this.$nextTick(() => {
        if (this.$refs.searchInput && this.$refs.searchInput.blur) {
          this.$refs.searchInput.blur();
        }
      });
    },
    bodyCloseMenus(e) {
      if (this.$refs.searchBox && !this.$refs.searchBox.contains(e.target)) {
        this.closeSearchPanels();
      }
    },
    loadHistory() {
      const key = "cdf_sunrise_search_history";
      try {
        this.searchHistory = JSON.parse(localStorage.getItem(key) || "[]");
        if (!Array.isArray(this.searchHistory)) {
          this.searchHistory = [];
        }
      } catch (error) {
        this.searchHistory = [];
      }
    },
    saveHistory(keyword) {
      if (!keyword || !keyword.trim()) return;
      const key = "cdf_sunrise_search_history";
      const value = keyword.trim();
      let history = [];
      try {
        history = JSON.parse(localStorage.getItem(key) || "[]");
        if (!Array.isArray(history)) {
          history = [];
        }
      } catch (error) {
        history = [];
      }
      history = history.filter((item) => item !== value);
      history.unshift(value);
      history = history.slice(0, 10);
      localStorage.setItem(key, JSON.stringify(history));
      this.searchHistory = history;
    },
    clearHistory() {
      const key = "cdf_sunrise_search_history";
      localStorage.removeItem(key);
      this.searchHistory = [];
    },
    handleScrollLoadMore() {
      if (this.loading || !this.hasMore) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const fullHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      if (scrollTop + viewportHeight + 200 >= fullHeight) {
        this.getGoodsList(true);
      }
    },
    async handleGoodsClick(item) {
      if (!item.origin_id) {
        this.$message.warning("商品ID不存在");
        return;
      }
      this.promoteLoading = true;
      this.promoteDialogVisible = true;
      this.promoteResult = null;
      this.shortLink = "";
      this.promoteText = "";
      this.currentPromoteGoods = item;
      try {
        const response = await getGoodsUrl({ origin_id: item.origin_id });
        if (response && response.data) {
          const convertInfo = response.data.convert_info || {};
          this.shortLink = convertInfo.short_link || "";
          if (!this.shortLink) {
            this.$message.error("转链接口未返回推广链接");
            return;
          }
          this.promoteResult = { short_link: this.shortLink };
          this.promoteText = this.buildPromoteText(item, this.shortLink);
        } else {
          this.$message.error("获取推广链接失败");
        }
      } catch (error) {
        console.error("获取推广链接失败:", error);
        this.$message.error("获取推广链接失败，请稍后重试");
      } finally {
        this.promoteLoading = false;
      }
    },
    handleOpenGoods(item) {
      const goodsId = this.extractRealGoodsId(item && item.origin_id);
      if (!goodsId) {
        this.$message.warning("商品ID格式不正确，无法打开");
        return;
      }
      const query = encodeURIComponent(`page=item&goodsID=${goodsId}&source_from=productshare`);
      const url = `weixin://dl/business/?appid=wx82028cdb701506f3&path=pages/main/product/subject/detail/index&query=${query}&env_version=`;
      window.open(url, "_self");
    },
    copyField(fieldName, value) {
      if (!value) {
        this.$message.warning("内容为空，无法复制");
        return;
      }
      this.$copyText(value).then(
        () => this.$message.success(`${this.getCopyLabel(fieldName)}复制成功`),
        () => this.$message.error("复制失败，请手动复制")
      );
    },
    handlePromoteDialogClose() {
      this.promoteResult = null;
      this.promoteText = "";
      this.currentPromoteGoods = null;
    },
    updateDeviceType() {
      this.isMobile = window.innerWidth <= 768;
    },
    getCopyLabel(fieldName) {
      const labelMap = {
        short_link: "推广链接",
        promote_text: "推广文案",
      };
      return labelMap[fieldName] || "内容";
    },
    openShortLink() {
      if (!this.shortLink) {
        this.$message.warning("推广链接为空，无法打开");
        return;
      }
      window.location.href = this.shortLink;
    },
    buildPromoteText(item, link) {
      if (!item) return "";
      return [
        `【商品名称】 ${item.title || ""}`,
        `【商品价格】 ￥${item.final_price || item.origin_price || ""}`,
        `【下单链接】 ${link || ""}`,
      ].join("\n");
    },
    getIncomeRate(item) {
      if (!item) return 0;
      const rate = parseFloat(item.fan_price_tkrates || item.tkrates_raw || 0);
      return (isNaN(rate) ? 0 : rate).toFixed(1);
    },
    formatNumber(num) {
      if (!num) return "0";
      const number = parseFloat(num);
      return isNaN(number) ? "0" : number.toFixed(2);
    },
    formatSales(num) {
      if (!num) return "0";
      const number = Number(num);
      if (isNaN(number)) return num || "0";
      return number >= 10000 ? (number / 10000).toFixed(1) + "万" : number.toString();
    },
    extractRealGoodsId(originId) {
      if (!originId) return "";
      try {
        const decodedId = decodeURIComponent(originId);
        const parts = decodedId.split("|");
        return parts.length >= 3 ? parts[1] : "";
      } catch (error) {
        return "";
      }
    },
    copyGoodsId(id) {
      if (!id) return;
      const realId = this.extractRealGoodsId(id);
      this.$copyText(realId).then(
        () => this.$message.success("商品ID复制成功"),
        () => this.$message.error("复制失败，请手动复制")
      );
    },
    copyGoodsLink(link) {
      if (!link) return;
      this.$copyText(link).then(
        () => this.$message.success("商品链接复制成功"),
        () => this.$message.error("复制失败，请手动复制")
      );
    },
  },
};
</script>

<style lang="scss" scoped>

.dygaoyong-page {
  --main-color: #f40042;
  --main-bg-color: #f40042;
  padding: 20px;
  min-height: calc(100vh - 60px);
  background-color: #f8f9fa;
}

.page-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px 0 60px;

  .header-search {
    width: 100%;
    max-width: 700px;

    .search-box {
      position: relative;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;

      .history-box,
      .suggest-box {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        background: #fff;
        box-shadow: 2px 2px 5px rgba(100, 100, 100, 0.1), -2px 2px 5px rgba(100, 100, 100, 0.1);
        border-radius: 0 0 10px 10px;
        z-index: 9999;

        .history-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 20px 5px;
          color: #999;
          font-size: 13px;

          .history-clear {
            font-size: 12px;
            cursor: pointer;
            color: #999;

            &:hover {
              color: #666;
            }
          }
        }

        ul {
          margin: 0;
          padding: 0;
          list-style: none;
          max-height: 260px;
          overflow-y: auto;

          .history-item,
          .suggest-item {
            padding: 8px 20px;
            cursor: pointer;
            color: #666;
            font-size: 14px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &:hover {
              background: #f2f2f2;
            }

            .el-icon-time,
            .el-icon-search {
              margin-right: 6px;
              vertical-align: middle;
            }
          }
        }
      }
    }

    .search-row {
      display: flex;
      align-items: stretch;
      width: 100%;
      height: 48px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      overflow: hidden;
      background: #fff;
      box-sizing: border-box;
    }

    .search-input-large {
      flex: 1 1 auto;
      min-width: 0;

      ::v-deep .el-input__inner {
        height: 46px;
        border: none;
        border-radius: 0;
        font-size: 16px;
        padding: 0 15px;
      }
    }

    .search-button {
      flex: 0 0 100px;
      width: 100px;
      height: 48px;
      margin: -1px -1px -1px 0;
      border: none;
      border-radius: 0 4px 4px 0;
      color: #ffffff;
      font-size: 16px;
      background-color: var(--main-bg-color);

      &:hover {
        background-color: #f40042;
      }

      &:active {
        background-color: #2c75a3;
      }
    }

  }
}

.live-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 4px;
  backdrop-filter: blur(4px);
  max-width: calc(100% - 12px);

  .live-gif {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .live-author {
    color: #fff;
    font-size: 13px;
    line-height: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.card-container {
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid #ebeef5;

  ::v-deep .el-card__body {
    padding: 20px;
  }
}

.filter-section {
  .filter-group {
    display: flex;
    align-items: flex-start;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    .filter-label {
      font-weight: 500;
      margin-right: 15px;
      min-width: 80px;
      color: #606266;
      line-height: 32px;
    }

    .sort-buttons {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .sort-item {
      display: flex;
      align-items: center;
      gap: 5px;
      margin: 6px 12px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        color: var(--main-bg-color);
      }

      &.active {
        color: var(--main-bg-color);
      }

      .sort-label {
        font-size: 14px;
        user-select: none;
      }

      .sort-arrows {
        display: flex;
        flex-direction: column;
        margin-left: 4px;

        i {
          font-size: 11px;
          line-height: 1;
          color: #909399;
          transition: color 0.3s;
          cursor: pointer;

          &:hover {
            color: var(--main-bg-color);
          }

          &.active {
            color: var(--main-bg-color);
            font-weight: bold;
          }
        }
      }
    }

    ::v-deep {
      .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        max-width: 100%;
      }

      .el-radio-button__inner {
        border-radius: 6px !important;
        border: 1px solid #dcdfe6 !important;
        margin: 0 !important;
        transition: all 0.3s;
      }

      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        box-shadow: none !important;
        border-color: var(--main-bg-color) !important;
      }

      .el-radio-button:first-child .el-radio-button__inner,
      .el-radio-button:last-child .el-radio-button__inner {
        border-radius: 6px !important;
      }
    }
  }
}

.goods-list {
  .empty-data {
    padding: 40px 0;
    text-align: center;
    color: #909399;
    font-size: 14px;
  }

  // 高佣库 keyword 搜索结果样式（已合并到主列表，仅保留标题样式可复用时使用）
  .hc-search-title {
    margin: 0 0 10px 0;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  .no-cps-tip {
    padding: 20px;
    text-align: center;
    background: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 4px;
    margin-bottom: 20px;

    p {
      margin: 0;
      color: #856404;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .recommend-title {
    margin-bottom: 20px;
    padding: 15px 20px;
    background: #f0f9ff;
    border-left: 4px solid var(--main-bg-color);
    border-radius: 4px;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }
  }

  .goods-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 15px;
    width: 100%;
    margin: 0 auto;
  }

  .goods-item {
    margin-bottom: 15px;
  }

  .goods-card {
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 360px;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    }
  }

  .goods-image {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    /* 1:1 比例 */
    position: relative;
    overflow: hidden;
    background-color: #f9f9f9;
    border-bottom: 1px solid #f0f0f0;

    ::v-deep .el-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        border-radius: 8px 8px 0 0;
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.05);
        }
      }
    }

    .image-slot {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: #f5f7fa;
      color: #909399;
      font-size: 24px;
    }
  }

  .goods-content {
    padding: 10px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .goods-title {
    font-size: 14px;
    color: #222222;
    line-height: 1.4;
    margin-bottom: 5px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 36px;
    cursor: pointer;
  }
  .sub-title {
    font-size: 12px;
    color: #f03d3d;
    line-height: 1.2;
    margin-bottom: 8px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    cursor: pointer;
  }
  .commission-rate-comparison {
    margin-bottom: 8px;
    padding: 8px;
    background: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;

    .rate-item {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      font-size: 13px;

      &:last-child {
        margin-bottom: 0;
      }

      &.highlight {
        .rate-value {
          color: #f56c6c;
          font-weight: bold;
          font-size: 15px;
        }

        .rate-tip {
          margin-left: 8px;
          color: #f56c6c;
          font-weight: bold;
          font-size: 12px;
        }
      }

      .rate-label {
        color: #606266;
        margin-right: 5px;
      }

      .rate-value {
        color: #303133;
        font-weight: 500;
      }
    }
  }

  .price-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .price-info {
    line-height: 1;
    .current-price {
      color: #e2231a;
      font-weight: bold;

      .price-number {
        font-size: 26px;
      }
    }

    .original-price {
      color: #999;
      font-size: 13px;
      text-decoration: line-through;
      margin-top: 2px;
    }
  }

  .goods-tags {
    text-align: right;
    line-height: 1.2;
    .price-tag {
      font-size: 14px;
      margin-left: 3px;
      margin-bottom: 3px;
      font-weight: bold;
      transform-origin: right center;
    }
    .commission-rate {
      color: #ff3b52;
      font-size: 14px;
      margin-bottom: 3px;
      font-weight: bold;
      transform-origin: right center;
    }
    .commission-text {
      // color: #ff9012;
      color: #ff3b52;
      font-size: 14px;
      transform-origin: right center;
    }
  }
  .sales-info-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .shop-title {
      font-size: 13px;
      color: #ffffff;
      background: #ff3b52;
      border-radius: 4px;
      padding: 2px 8px;

    }
    .sales-info {
      display: flex;
      align-items: center;
      .sales-text {
        font-size: 12px;
        color: #909399;
      }
    }
  }
  .sales-info {
    display: flex;
    align-items: center;
    .sales-text {
      font-size: 12px;
      color: #909399;
    }
  }
  .meta-bar {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    background: #fafafa;
    border-radius: 8px;
    padding: 12px 4px;
    .meta-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      text-align: center;
      border-right: 1px solid #e2e2e2;

      &:last-child {
        border-right: none;
      }
    }
    .meta-item--primary .meta-value {
      color: #e2231a;
      font-size: 18px;
    }

    .meta-label {
      font-size: 12px;
      color: #94a3b8;
      line-height: 1;
    }

    .meta-value {
      font-size: 20px;
      color: #475569;
      font-weight: 700;
      line-height: 1.2;
    }
  }
  
  
  .action-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: auto;
    padding-top: 10px;
    // border-top: 1px solid #f0f0f0;

    ::v-deep .el-button {
      padding: 10px;
      font-size: 14px;
      color: var(--main-bg-color) !important;
      border: 1px solid var(--main-bg-color) !important;
      background: transparent !important;
      border-radius: 100px;
      &:hover {
        background: var(--main-bg-color) !important;
        color: #ffffff !important;
      }
    }
    .goods-id {
      .id-text {
        font-size: 12px;
        color: #919191;
        cursor: pointer;
        display: inline-block;

        &:hover {
          text-decoration: underline;
        }

        i {
          margin-right: 3px;
        }
      }
    }
  }
}

.load-more {
  text-align: center;
  padding: 20px 0;

  p {
    margin: 0;
    font-size: 14px;
    color: #909399;
  }

  .loading-text {
    color: var(--main-bg-color);

    i {
      margin-right: 5px;
    }
  }

  .no-more-text {
    color: #909399;
  }

  .load-more-text {
    color: #909399;
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .goods-list {
    .goods-grid {
      grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    }
  }
}

@media (max-width: 1200px) {
  .goods-list {
    .goods-grid {
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      max-width: 1000px;
    }

    .goods-card {
      min-height: 340px;
    }
  }
}

@media (max-width: 992px) {
  .goods-list {
    .goods-grid {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      max-width: 800px;
    }

    .goods-card {
      min-height: 330px;
    }

    .goods-title {
      min-height: 38px;
      -webkit-line-clamp: 2;
      font-size: 13px;
    }
  }
}

@media (max-width: 768px) {
  .dygaoyong-page {
    padding: 10px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    margin: 12px 0 14px;
    width: 100%;

    .header-search {
      width: 100%;
      max-width: none;

      .search-box,
      .search-row {
        width: 100%;
      }

      .search-row {
        height: 40px;
      }

      .search-input-large {
        flex: 1 1 auto;
        min-width: 0;

        ::v-deep .el-input__inner {
          height: 38px;
          padding: 0 10px;
          font-size: 13px;
        }
      }

      .search-button {
        flex-basis: 52px;
        width: 52px;
        height: 40px;
        padding: 0;
        font-size: 0;

        ::v-deep i {
          margin-right: 0;
          font-size: 15px;
        }

        ::v-deep span {
          display: none;
        }
      }
    }
  }

  .card-container {
    margin-bottom: 12px;

    ::v-deep .el-card__body {
      padding: 12px;
    }
  }

.filter-group {
      flex-direction: column;
      align-items: flex-start;
      width: 100%;

      .filter-label {
        margin-bottom: 10px;
        line-height: normal;
      }

      &:first-child {
        ::v-deep .el-radio-group {
          display: flex;
          flex-wrap: nowrap;
          gap: 0;
          width: 100%;
          overflow-x: auto;
          overflow-y: hidden;
          padding-bottom: 4px;
          white-space: nowrap;
          -webkit-overflow-scrolling: touch;
        }

        ::v-deep .el-radio-button {
          flex: 0 0 auto;
        }

        ::v-deep .el-radio-button__inner {
          margin-right: 8px !important;
        }
      }

      .sort-buttons {
        width: 100%;
        overflow-x: auto;
        padding-bottom: 4px;
        gap: 2px;
        -webkit-overflow-scrolling: touch;
      }

      .sort-item {
        flex: 0 0 auto;
        margin: 6px 10px 6px 0;
      }
    }

  .goods-list {
    .goods-grid {
      grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
      gap: 10px;
    }

    .goods-card {
      min-height: 320px;
    }

    .goods-content {
      padding: 8px;
    }

    .goods-title {
      font-size: 12px;
      margin-bottom: 6px;
      min-height: 34px;
    }

    .price-info {
      .current-price .price-number {
        font-size: 15px;
      }
    }

    .action-row {
      flex-direction: column;
      align-items: flex-start;

      .goods-id {
        margin-bottom: 6px;
      }

      .el-button {
        width: 100%;
        padding: 5px 10px;
        font-size: 12px;
      }
    }
  }

  .promote-dialog {
    ::v-deep .el-dialog {
      max-width: calc(100vw - 24px);
      margin-top: 8vh !important;
    }

    ::v-deep .el-dialog__body {
      padding: 14px;
    }

    ::v-deep .el-dialog__footer {
      padding: 10px 14px 14px;
    }
  }

  .promote-result {
    max-height: 68vh;
    min-height: 160px;
    overflow-y: auto;

    .promote-fields {
      .promote-field {
        margin-bottom: 14px;

        .field-value {
          flex-direction: column;
          gap: 8px;

          .field-input,
          .el-button {
            width: 100%;
            background: #f5f7fa;
          }
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .goods-list {
    .goods-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
    }

    .goods-card {
      min-height: 300px;
    }

    .goods-title {
      font-size: 12px;
    }
  }
}

// 推广弹窗样式
.promote-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
}

.promote-result {
  min-height: 200px;

  .promote-fields {
    .promote-field {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      label {
        display: block;
        margin-bottom: 8px;
        font-weight: 500;
        color: #606266;
        font-size: 14px;
      }

      .field-value {
        display: flex;
        gap: 10px;
        align-items: flex-start;

        .field-input {
          flex: 1;
          min-width: 0;

          ::v-deep .el-textarea__inner {
            font-family: "Courier New", monospace;
            font-size: 12px;
            line-height: 1.5;
          }
        }

        .promote-copy {
          ::v-deep .el-textarea__inner {
            font-family: inherit;
            color: #303133;
          }
        }

        .el-button {
          white-space: nowrap;
        }
      }
    }
  }

  .deeplink-button {
    width: 100%;
  }
}
/* 针对 single-goods-card 的特殊布局 */
.single-goods-card {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)) !important;
}
.commission-pk-container {
  display: flex;
  align-items: stretch; // 让左右高度一致
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  .pk-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 4px;
    position: relative;

    &.loser {
      background: #f5f7fa;
      color: #333333;

      .label {
        font-size: 12px;
        margin-bottom: 2px;
      }
      .value {
        font-size: 14px;
        font-weight: 500;
      }
    }

    &.winner {
      background: #fff1f0; // 浅红色背景烘托
      color: #f12727;
      flex: 1.3; // 让赢家占据更大空间

      .badge {
        position: absolute;
        top: 0;
        right: 0;
        background: #f12727;
        color: #fff;
        font-size: 10px;
        padding: 1px 6px;
        border-bottom-left-radius: 6px;
      }

      .label {
        font-size: 14px;
        opacity: 0.8;
        margin-bottom: 2px;
      }

      .value-group {
        display: flex;
        align-items: baseline;

        .num {
          font-size: 20px; // 放大数字
          font-weight: bold;
          line-height: 1;
        }

        .up-tag {
          font-size: 14px;
          background: #e23232;
          color: white;
          padding: 1px 4px;
          border-radius: 4px;
          margin-left: 4px;
          transform: scale(0.9);
        }
      }
    }
  }

  .pk-divider {
    width: 0;
    position: relative;
    z-index: 1;

    .vs-tag {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border: 1px solid #e4e7ed;
      color: #c0c4cc;
      font-size: 10px;
      padding: 2px;
      border-radius: 50%;
      font-weight: bold;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
